import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "Current Patients | Neuro Wellness TMS Centers of America",
  description:
    "Resources for current patients of Neuro Wellness TMS Centers of America: follow-up care, maintenance, medications, and what to expect.",
  canonical: "/current-patients",
  keywords:
    "current patients TMS, Neuro Wellness current patient resources, TMS follow-up care, SAINT follow-up",
};

const relatedLinks = [
  { title: "Maintenance and Relapse", href: "/maintenance-and-relapse" },
  { title: "Medications After TMS", href: "/medications-after-tms" },
  { title: "What TMS Feels Like", href: "/what-tms-feels-like" },
  { title: "Schedule a Follow-Up", href: "/contactus" },
];

export default function CurrentPatients() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Current Patients"
      title="Current Patients"
      subtitle="Resources and information for patients currently in treatment or recently completed treatment at Neuro Wellness TMS Centers of America."
    >
      <DecisionSection heading="Follow-up care">
        <p>
          After completing a course of TMS, SAINT, or other treatment, your care
          team schedules follow-up assessments to track your progress. These
          typically happen at one week, one month, and at longer intervals as
          needed.
        </p>
        <p>
          If you're between follow-up appointments and have questions, call us
          at{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>
          .
        </p>
      </DecisionSection>

      <DecisionSection heading="What to watch for">
        <p>After treatment, pay attention to:</p>
        <DecisionList
          items={[
            "Changes in mood, sleep, energy, or concentration",
            "Any return of symptoms you experienced before treatment",
            "Side effects from current medications",
            "How you're functioning at work, home, and in relationships",
          ]}
        />
        <p>
          If symptoms return, contact us. Depression can recur after any
          treatment, and early intervention helps.
        </p>
      </DecisionSection>

      <DecisionSection heading="Medication questions">
        <p>
          Decisions about continuing, adjusting, or stopping medication after
          TMS should be made with your prescriber. Do not stop any medication
          without consulting your prescriber first.{" "}
          <Link
            to="/medications-after-tms"
            className="text-accent hover:underline"
          >
            Learn more about medications after TMS
          </Link>
          .
        </p>
      </DecisionSection>

      <DecisionSection heading="Maintenance sessions">
        <p>
          If you're interested in maintenance or booster TMS sessions, talk to
          your care team. Whether maintenance is appropriate depends on your
          clinical situation and your insurance plan's coverage.{" "}
          <Link
            to="/maintenance-and-relapse"
            className="text-accent hover:underline"
          >
            Learn more about maintenance and relapse
          </Link>
          .
        </p>
      </DecisionSection>

      <DecisionSection heading="If you're in crisis">
        <p>
          If you're in crisis or need someone to talk to right now, call or text
          988 any time — the Suicide and Crisis Lifeline is available 24/7. If
          you're in immediate danger, call 911.
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
